import { render, staticRenderFns } from "./B-5-4__Career_JobInformation.vue?vue&type=template&id=22827e97&"
import script from "./B-5-4__Career_JobInformation.vue?vue&type=script&lang=js&"
export * from "./B-5-4__Career_JobInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports